import Task from "../../../../model2/task/task"
import {ProjectAccess} from "../../../../gd/const/project"
import CompanyUser from "../../../../model2/company-user-new/company-user"
import UserToAdd from "../add-user"
import {getAllProjectIds, getAllWorkspaceProjectIds, getUsersOnAllTasks} from "./helpers"


// Users that already belong to EVERY workspace the selected tasks live in but
// are missing from at least one of the sub-projects. Picking such a user has
// the backend add them to the missing project(s) only - the workspace
// membership is already there.
export function bulkComputeWorkspaceUsers(tasks: Task[], taskUserIdsByTaskId: Map<ID, ID[]>): UserToAdd[] {
    const allWorkspaceProjectIds = getAllWorkspaceProjectIds(tasks)

    // No workspaces involved -> there is no "workspace users" bucket; anyone
    // that still needs a project add lives in the company bucket.
    if (!allWorkspaceProjectIds.length) return []

    const allProjectIds = getAllProjectIds(tasks)
    const onAllTasks    = getUsersOnAllTasks(tasks, taskUserIdsByTaskId)

    const models : UserToAdd[] = []

    _.each(gd.session.companyUsers.notClients(), (companyUser: CompanyUser) => {
        const userId = companyUser.userId

        if (onAllTasks.has(userId)) return

        const inAllWorkspaces = _.every(allWorkspaceProjectIds, (wpId: ID) => {
            const ws = gd.session.projects.get(wpId)
            return !!ws && ws.userIds().includes(userId)
        })
        if (!inAllWorkspaces) return

        const inAllProjects = _.every(allProjectIds, (projectId: ID) => {
            const project = gd.session.projects.get(projectId)
            return !!project && project.userIds().includes(userId)
        })
        if (inAllProjects) return // belongs to projectUsersToAdd

        const userToAdd = new UserToAdd(companyUser)
        userToAdd.projectAccess = ProjectAccess.STANDARD
        models.push(userToAdd)
    })

    return models
}
